import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import '../CSS/user-list.css';
import { ENDPOINTS } from '../Helper/endpoints';
import Footer from "./Footer";
import * as XLSX from 'xlsx';
import { Chart } from 'chart.js/auto';


const getCookie = (cookieName) => {
  const cookies = document.cookie.split('; ');
  for (let cookie of cookies) {
    const [name, value] = cookie.split('=');
    if (name === cookieName) return decodeURIComponent(value);
  }
  return null;
};

function UserList({ setCurrentPage }) {
  const [users, setUsers] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const [bankDetailsList, setBankDetailsList] = useState([]);

  useEffect(() => {
    const getOrganizationsPid = () => {
      const userSessionData = getCookie('userSession');
      if (userSessionData) {
        try {
          const parsedSessionData = JSON.parse(userSessionData);
          return parsedSessionData.data.organization_info.pid;
        } catch (e) {
          console.error('Error parsing organizations_pid from cookie:', e);
          return null;
        }
      }
      return null;
    };

    const pid = getOrganizationsPid();
    if (!pid) {
      // setError('Organization PID not found in cookies.');
      // setLoading(false);
      return;
    }
    axios.get(ENDPOINTS.USER_INFO, { params: { organization_pid: pid } })
      .then((response) => {
        if (response.data.status) {
          setUsers(response.data.data);
        } else {
          throw new Error('Failed to fetch users');
        }
        // setLoading(false);
      })
      .catch((error) => {
        // setError(error.message);
        // setLoading(false);
      }); axios.get(ENDPOINTS.BANK_INFO, { params: { organization_pid: pid } })
        .then((response) => {
          if (response.data.status) {
            setBankDetailsList(response.data.data);
          } else {
            throw new Error('Failed to fetch bank details');
          }
        })
        .catch((error) => {
          console.error('Failed to fetch bank details:', error);
          // Removed the Swal.fire popup message
        });
  }, []);

  const validateBankDetails = (details) => {
    const errors = {};
    // Bank Name Validation
    if (!details.Bank_name || !details.Bank_name.trim()) {
      errors.Bank_name = "Bank Name is required";
    } else if (details.Bank_name.trim().length < 2) {
      errors.Bank_name = "Bank Name must be at least 2 characters long";
    }
    // Branch Validation
    if (!details.branch_name || !details.branch_name.trim()) {
      errors.branch_name = "Branch is required";
    } else if (details.branch_name.trim().length < 2) {
      errors.branch_name = "Branch must be at least 2 characters long";
    }
    // Account Number Validation
    if (!details.Account_number || !details.Account_number.trim()) {
      errors.Account_number = "Account Number is required";
    } else if (!/^\d{9,18}$/.test(details.Account_number.trim())) {
      errors.Account_number = "Account Number must be 9-18 digits";
    }
    // Account Holder Name Validation
    if (!details.Account_holder_name || !details.Account_holder_name.trim()) {
      errors.Account_holder_name = "Account Holder Name is required";
    } else if (details.Account_holder_name.trim().length < 2) {
      errors.Account_holder_name = "Account Holder Name must be at least 2 characters long";
    } else if (!/^[A-Za-z\s]+$/.test(details.Account_holder_name.trim())) {
      errors.Account_holder_name = "Account Holder Name must contain only letters and spaces";
    }
    // IFSC Code Validation
    if (!details.IFSC_code || !details.IFSC_code.trim()) {
      errors.IFSC_code = "IFSC Code is required";
    } else if (!/^[A-Z]{4}0[A-Z0-9]{6}$/.test(details.IFSC_code.trim())) {
      errors.IFSC_code = "Invalid IFSC Code format (e.g., HDFC0001234)";
    }
    // Optional UPI Code Validation
    if (details.upiCode && details.upiCode.trim()) {
      if (!/^[a-zA-Z0-9.-]+@[a-zA-Z0-9]+$/.test(details.upiCode.trim())) {
        errors.upiCode = "Invalid UPI Code format (e.g., user@bank)";
      }
    }
    return errors;
  };

  const handleAddBankDetails = () => {
    const getOrganizationsPid = () => {
      const userSessionData = getCookie('userSession');
      if (userSessionData) {
        try {
          const parsedSessionData = JSON.parse(userSessionData);
          return parsedSessionData.data.organization_info.pid;
        } catch (e) {
          console.error('Error parsing organizations_pid from cookie:', e);
          return null;
        }
      }
      return null;
    };

    Swal.fire({
      title: 'Add Bank Details',
      html: ` <style> 
              .bank-details-grid { display: grid; grid-template-columns: 1fr 1fr;
                gap: 15px; padding: 10px; }
              .input-container { position: relative; display: flex;
                flex-direction: column; }
              .swal2-input { width: 100%; padding: 10px; border: 1px solid #d1d1d1;
                border-radius: 4px; margin-bottom: 5px; }
              .error-text { color:rgb(175, 33, 48); font-size: 0.75em;
                margin-top: 2px; bottom: -18px; left: 0; padding: 2px 5px;
                border-radius: 3px; width: 100%;box-sizing: border-box; }
              .swal2-popup {width: 700px !important; }  </style>

            <div class="bank-details-grid">
              <div class="input-container">
                <input id="Bank_name" class="swal2-input" placeholder="Enter Bank Name">
                <div id="Bank_name-error" class="error-text"></div>
              </div>
              <div class="input-container">
                <input id="branch_name" class="swal2-input" placeholder="Enter Branch">
                <div id="branch_name-error" class="error-text"></div>
              </div>
              <div class="input-container">
                <input id="Account_number" class="swal2-input" placeholder="Enter Account Number">
                <div id="Account_number-error" class="error-text"></div>
              </div>
              <div class="input-container">
                <input id="Account_holder_name" class="swal2-input" placeholder="Enter Account Holder Name">
                <div id="Account_holder_name-error" class="error-text"></div>
              </div>
              <div class="input-container">
                <input id="IFSC_code" class="swal2-input" placeholder="Enter IFSC Code">
                <div id="IFSC_code-error" class="error-text"></div>
              </div>
              <div class="input-container">
                <input id="upi_id" class="swal2-input" placeholder="Enter UPI Code (Optional)">
                <div id="upiCode-error" class="error-text"></div>
              </div>
            </div> `,
      customClass: {
        popup: 'bank-details-popup', confirmButton: 'swal-save-btn',
        cancelButton: 'swal-cancel-btn'
      },
      showCancelButton: true, confirmButtonText: 'Save', cancelButtonText: 'Cancel',
      confirmButtonColor: '#191056', cancelButtonColor: '#191056',
      didRender: () => {
        // Clear any previous error messages
        ['Bank_name', 'branch_name', 'Account_number', 'Account_holder_name', 'IFSC_code', 'upiCode']
          .forEach(field => {
            document.getElementById(`${field}-error`).textContent = '';
          });
      },

      preConfirm: () => {
        const details = {
          Bank_name: document.getElementById('Bank_name').value || '',
          branch_name: document.getElementById('branch_name').value || '',
          Account_number: document.getElementById('Account_number').value || '',
          Account_holder_name: document.getElementById('Account_holder_name').value || '',
          IFSC_code: document.getElementById('IFSC_code').value || '',
          upi_id: document.getElementById('upi_id').value || ''
        };
        const validationErrors = validateBankDetails(details);
        // Display errors below respective fields
        Object.keys(validationErrors).forEach(field => {
          const errorElement = document.getElementById(`${field}-error`);
          if (errorElement) {
            errorElement.textContent = validationErrors[field];
          }
        });
        // If there are any errors, return false to prevent form submission
        if (Object.keys(validationErrors).length > 0) {
          return false;
        }
        return details;
      }
    }).then((result) => {
      if (result.isConfirmed) {
        // Get organization PID
        const organizationPid = getOrganizationsPid();
        if (!organizationPid) {
          Swal.fire({
            icon: 'error', title: 'Error',
            text: 'Organization PID not found. Please login again.'
          });
          return;
        }
        // Prepare payload for API
        const payload = { ...result.value, organization_pid: organizationPid };
        // Make API call to add bank details
        axios.post(ENDPOINTS.BANK_ADD, payload)
          .then((response) => {
            if (response.data.status) {
              // Update local state
              setBankDetailsList([...bankDetailsList, result.value]);
              Swal.fire({ icon: 'success', title: 'Saved!',
                text: 'Bank details have been saved successfully.',
                timer: 1500, showConfirmButton: false,
                customClass: { popup: "small-swal-popup" }, });
            } else {
              // Handle API response with status false
              Swal.fire({icon: 'error', title: 'Error',
                text: response.data.message || 'Failed to save bank details'});}})
          .catch((error) => {
            // Handle network or server errors
            Swal.fire({icon: 'error', title: 'Error',
              text: error.response?.data?.message || 'An error occurred while saving bank details'}); });}})};

  const handleReportClick = (user) => {
    const getOrganizationsPid = () => {
      const userSessionData = getCookie('userSession');
      if (userSessionData) {
        try {
          const parsedSessionData = JSON.parse(userSessionData);
          return parsedSessionData.data.organization_info.pid;
        } catch (e) {
          console.error('Error parsing organization_pid from cookie:', e);
          return null;
        }
      }
      return null;
    };

    const organizationPid = getOrganizationsPid();
    if (!organizationPid) {
      Swal.fire({icon: 'error',title: 'Error',
        text: 'Organization PID not found. Please login again.'});
      return; }

    const userPid = user.user_pid; // Adjust based on actual key in your API response

    if (!userPid) {
      Swal.fire({icon: 'error',title: 'Error',
        text: 'User PID is missing. Cannot fetch report.'});
      return;}

    axios.get(ENDPOINTS.USER_REPORT, {
      params: { organization_pid: organizationPid, user_pid: userPid }
    })
      .then((response) => {
        if (response.data.status && response.data.data) {
          const report = response.data.data;

          Swal.fire({title: `User Report - ${user.name}`,
            html: `
              <style>
                .report-table {
                  width: 100%;
                  border-collapse: collapse;
                  margin-top: 10px;
                }
                .report-table th, .report-table td {
                  border: 1px solid #ddd;
                  padding: 8px;
                  text-align: center;
                  font-size: 16px;
                }
                .report-table th {
                  background-color: #191056;;
                  font-weight: bold;
                  color:white;
                }
              </style>
              <table class="report-table">
                <thead>
                  <tr>
                  <th>Vendor Name</th>
                    <th>PR No</th>
                    <th>Invoice No</th>
                    <th>PR Date</th>
                    <th>Status</th>
                    <th>Net Payable</th>
                    <th>Bank Name</th>
                  </tr>
                </thead>
                <tbody>
                  ${report.map(item => `
                    <tr>
                      <td>${item.name || 'N/A'}</td>                    
                      <td>${item.pr_no || 'N/A'}</td>
                      <td>${item.invoice_no || 'N/A'}</td>
                      <td>${item.pr_date || 'N/A'}</td>
                      <td>${item.status || 'N/A'}</td>
                      <td>${item.net_payable || 'N/A'}</td>
                      <td>${item.org_Bank_name || 'N/A'}</td>
                    </tr>`).join('')}
                </tbody>
              </table>
            `,
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonText: 'Download',
            cancelButtonColor: '#191056',
            confirmButtonColor: '#191056',
            confirmButtonText: 'Close',
            width: '800px'
          })
            .then((result) => {
              if (result.dismiss === Swal.DismissReason.cancel) {
                downloadExcel(report);
              }
            });
        } else {
          throw new Error('Failed to fetch report data.');
        }
      })
      .catch((error) => {
        Swal.fire({icon: 'error',title: 'Error',
          text: error.response?.data?.message || 'Failed to fetch report data.'});});};

  const downloadExcel = (report) => {
    // Define headers
    const data = [
      ["Vendor Name", "Vendor Bank Name", "Vendor Branch", "Vendor Address", "Vendor Phone no", "Vendor Email",
        "Vendor Account Holder", "Vendor Account No", "Vendor Ifsc code", "Vendor UPI Id", "PR No", "Invoice No",
        "Invoice Date", "PR Date", "Reference", "Item", "HSN/SAC", "GST", "Quantity", "Rate", "Amount", "Sub Total", "CGST",
        "SGST", "Round Off", "Outstanding", "TDS", "TDS Percentage", "TDS Section", "Debit note", "Other Charges", "Advance",
        "Net Payable", "Organization Name", "Organization Address", "Organization GSTIN", "Organization Phone", "Organization Email",
        "Organization Aadhar No", "Organization Pan No", "Organization Bank Name", "Organization Branch", "Organization Account Holder",
        "Organization Account No", "Organization Ifsc code", "Organization Upi Id", "Status", "Created By Name", "Created By Role"]];
    // Append rows from report
    report.forEach(item => {
      // Handling multiple descriptions
      if (item.description && Array.isArray(item.description)) {
        item.description.forEach(desc => {
          data.push([
            item.name || "N/A", item.bank_name || "N/A", item.branch || "N/A", item.address || "N/A", item.mobile || "N/A",
            item.email || "N/A", item.account_holder_name || "N/A", item.account_number || "N/A", item.IFSC_code || "N/A",
            item.UPI_ID || "N/A", item.pr_no || "N/A", item.invoice_no || "N/A", item.invoice_date || "N/A", item.pr_date || "N/A",
            item.reference || "N/A", desc.item || "N/A", desc.HSN_SAC || "N/A", desc.GST || "N/A", desc.quantity || "N/A", "N/A",
            desc.Amount || "N/A", item.total_amount || "N/A", item.CGST || "N/A", item.SGST || "N/A", item.round_off || "N/A",
            item.outstanding || "N/A", item.TDS || "N/A", item.TDS_percentage || "N/A", item.TDS_section || "N/A",
            item.Debit_note || "N/A", item.other_charges || "N/A", item.advance || "N/A", item.net_payable || "N/A",
            item.org_name || "N/A", item.org_address || "N/A", item.org_GSTIN || "N/A", item.org_phone || "N/A", item.org_email || "N/A",
            item.org_aadhar_no || "N/A", item.org_pancard_no || "N/A", item.org_Bank_name || "N/A", item.org_bank_branch_name || "N/A",
            item.org_Account_holder_name || "N/A", item.org_Account_number || "N/A", item.org_IFSC_code || "N/A",
            item.org_upi_id || "N/A", item.status || "N/A", item.Created_by_name || "N/A", item.Created_by_role || "N/A"]); });}});
    // Create worksheet and workbook
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    // Generate filename and save file
    const createdByName = report[0]?.Created_by_name?.replace(/\s+/g, "_") || "Unknown";
    const fileName = `${createdByName}_Report.xlsx`;
    // Save the file
    XLSX.writeFile(wb, fileName);
  };

  const handleStatsClick = () => {
    const getOrganizationsPid = () => {
      const userSessionData = getCookie('userSession');
      if (userSessionData) {
        try {
          const parsedSessionData = JSON.parse(userSessionData);
          return parsedSessionData.data.organization_info.pid;
        } catch (e) {
          console.error('Error parsing organization_pid from cookie:', e);
          return null; } } return null;  };

    const organizationPid = getOrganizationsPid();
    if (!organizationPid) {
      Swal.fire({icon: 'error',title: 'Error',
        text: 'Organization PID not found. Please login again.' });
      return;}
    // Fetch both API responses with 'organizations_pid' in params
    Promise.all([
      axios.get(ENDPOINTS.COUNT_DATA, { params: { organizations_pid: organizationPid } }),
      axios.get(ENDPOINTS.INVOICES_INFO, { params: { organizations_pid: organizationPid } })])
      .then(([countResponse, invoicesResponse]) => {
        if (!countResponse.data.status || !invoicesResponse.data.status) {
          throw new Error('Failed to fetch stats data.');
        }
        const countData = countResponse.data.data;
        const invoicesData = countResponse.data.data;
        let recentInvoice = null;
        if (invoicesResponse?.data?.data && Array.isArray(invoicesResponse.data.data)) {
          const invoiceList = invoicesResponse.data.data;
          if (invoiceList.length > 0) {
            recentInvoice = invoiceList[0]; } }

        Swal.fire({ title: "Organization Stats",
          width: "800px", html: `
        <style>
          .stats-container {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            gap: 16px;
            max-width: 1000px;
            margin: 0 auto;
          }
          .stats-container > div {
            flex: 0 0 calc(33.33% - 16px);
          }
         .invoice-container {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 24px;
          background-color: #f2edf3;
          padding: 20px;
          margin-top: 16px;
          border-radius: 8px; }

    .invoice-card {
  flex: 0 1 45%; /* Takes up ~45% of container, allowing 2 side by side */
  max-width: 500px; /* Optional: cap the width */
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  padding: 16px;
}
          .invoice-header {
            background: #191056;
            color: white;
            text-align: center;
            padding: 8px;
            font-size: 16px;
            font-weight: bold;
          }     
       .invoice-content {
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.invoice-row {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  font-size: 14px;
  background-color: #f9f9f9;
  padding: 8px;
  border-radius: 6px;
}
.invoice-row > div {
  flex: 1;
  min-width: 120px;
}
.invoice-status {
  font-size: 14px;
  font-weight: bold;
  background-color: #f1f1f1;
  padding: 8px;
  border-radius: 6px;
}
#pieChartContainer {
  height: 300px;
  width: 300px;
  margin: auto;
}
        </style>
        <div class="stats-container">
          <div class="card-1"><div>Total Payment Recommendation<br>${countData.invoices_count || 'N/A'}</div></div>
          <div class="card-2"><div>Total Vendors<br>${countData.total_vendors || 'N/A'}</div></div>
          <div class="card-3"><div>Total Users<br>${countData.total_users || 'N/A'}</div></div>
          <div class="card-4"><div>Total Amount<br>₹${countData.total_amount || 'N/A'}</div></div>
          <div class="card-5"><div>Paid Amount<br>₹${countData.paid_amount || 'N/A'}</div></div>
          <div class="card-6"><div>Unpaid Amount<br>₹${countData.unpaid_amount || 'N/A'}</div></div>
        </div>
        <div class="invoice-container">
          <div class="invoice-card">
            <div class="invoice-header">Latest Created Payment Recommendation</div>
          <div class="invoice-content">
  ${recentInvoice ? `
    <div class="invoice-row">
      <div><strong>Vendor:</strong> ${recentInvoice.name}</div>
      <div><strong>Amount:</strong> ₹${recentInvoice.net_payable}</div>
    </div>
    <div class="invoice-row">
      <div><strong>PR No:</strong> ${recentInvoice.pr_no}</div>
      <div><strong>PR Date:</strong> ${new Date(recentInvoice.pr_date).toLocaleDateString('en-GB')}</div>
    </div>
    <div class="invoice-row">
      <div><strong>Invoice No:</strong> ${recentInvoice.invoice_no}</div>
      <div><strong>Invoice Date:</strong> ${new Date(recentInvoice.invoice_date).toLocaleDateString('en-GB')}</div>
    </div>
    <div class="invoice-status">
      <strong>Status:</strong> <span>${recentInvoice.status}</span>
    </div>
  ` : `<p>No recent invoices</p>`}
</div>
          </div>      
          <div class="invoice-card">
            <div class="invoice-header">Paid & Unpaid Payment</div>
            <div id="pieChartContainer" style="height: 300px;"></div>
          </div>
        </div>
      `,
          didOpen: () => {
            setTimeout(() => {
              renderPieChart([
                { name: "Paid", value: invoicesData.paid_amount || 0, color: "#1399EC" },
                { name: "Unpaid", value: invoicesData.unpaid_amount || 0, color: "#EC6613" }
              ]);}, 200); },
          showCloseButton: true,
          confirmButtonText: "Close",
          confirmButtonColor: "#191056", }); })
      .catch(error => {
        Swal.fire({icon: 'error',title: 'Error',
          text: error.response?.data?.message || 'Failed to fetch stats data.'});});};
  // Function to render pie chart
  let currentChart = null;
  const renderPieChart = (data) => {
    const chartContainer = document.getElementById("pieChartContainer");
    if (!chartContainer) return;
    chartContainer.innerHTML = ""; // Clear previous content
    const canvas = document.createElement("canvas");
    canvas.width = 300;
    canvas.height = 300;
    canvas.style.width = "100%";
    canvas.style.height = "100%";
    chartContainer.appendChild(canvas);
    if (currentChart) currentChart.destroy(); // Destroy old chart if exists
    currentChart = new Chart(canvas, {
      type: "pie",
      data: {labels: data.map(d => d.name),
        datasets: [{data: data.map(d => d.value),
          backgroundColor: data.map(d => d.color)}]},
      options: {responsive: true,
        maintainAspectRatio: false} }); };

  return (
    <>
      <div className="container-userlist">
        <div className="button-container">
          <button
            className="add-vendor-button"
            onClick={() => setCurrentPage('UsersForm')} >
            Add User
          </button>
          <button className="add-vendor-button" onClick={handleStatsClick}>
            Stats
          </button>
        </div>
        <table className="user-table">
          <thead>
            <tr>
              <th>Full Name</th>
              <th>Role</th>
              <th>Email ID</th>
              <th>Password</th>
              <th>Phone Number</th>
              <th style={{ textAlign: 'center' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {users.length > 0 ? (
              users.map((user) => (
                <tr key={user.id}>
                  <td>{user.name}</td>
                  <td>{user.role}</td>
                  <td>{user.email}</td>
                  <td>{user.password}</td>
                  <td>{user.contact}</td>
                  <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <button
                      className='add-report'
                      onClick={() => handleReportClick(user)} 
                    >
                      Report
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6">No users found</td>
              </tr>
            )}
          </tbody>
        </table>
        <div className="button-container">
          <button
            className="add-bank-button"
            onClick={handleAddBankDetails} >
            Add Bank Details
          </button>
        </div>
        <table className="user-table">
          <thead>
            <tr>
              <th>Bank Name</th>
              <th>Branch</th>
              <th>Account Number</th>
              <th>Account Holder</th>
              <th>IFSC Code</th>
              <th>UPI Code</th>
            </tr>
          </thead>
          <tbody>
            {bankDetailsList.length > 0 ? (
              bankDetailsList.map((bank, index) => (
                <tr key={index}>
                  <td>{bank.Bank_name}</td>
                  <td>{bank.branch_name}</td>
                  <td>{bank.Account_number}</td>
                  <td>{bank.Account_holder_name}</td>
                  <td>{bank.IFSC_code}</td>
                  <td>{bank.upi_id}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" style={{ textAlign: 'center' }}>No bank details found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Footer />
    </>
  );
}
export default UserList;